export class PpcInformationsComplementaires {
  ppcTypeSlug: string;
  examen_realise: 'polysomnographie' | 'polygraphie';
  microEveils?: number;
  iahGap: 'lt15' | 'gt15_lt30' | 'gt30';
  compteRendu?: string;
  somnolenceDiurne: boolean;
  ronflementsSeveres: boolean;
  cephaleesMatinales: boolean;
  fatigueDiurne: boolean;
  nycturie: boolean;
  sensationEtouffement: boolean;
  somnolenceDiurneSevereRisqueAccidentel: boolean;
  comorbiditeCardioVasculaireGrave: boolean;
  comorbiditeRespiratoireGrave: boolean;
  oam12DerniersMoisNon: boolean;
  reglage?: string;
  recapitulatif?: string | null;

  constructor(
    ppcTypeSlug: string,
    examen_realise: 'polysomnographie' | 'polygraphie',
    microEveils: number | undefined,
    iahGap: 'lt15' | 'gt15_lt30' | 'gt30',
    somnolenceDiurne: boolean,
    ronflementsSeveres: boolean,
    cephaleesMatinales: boolean,
    fatigueDiurne: boolean,
    nycturie: boolean,
    sensationEtouffement: boolean,
    somnolenceDiurneSevereRisqueAccidentel: boolean,
    comorbiditeCardioVasculaireGrave: boolean,
    comorbiditeRespiratoireGrave: boolean,
    oam12DerniersMoisNon: boolean,
    compteRendu?: string,
    reglage?: string,
    recapitulatif?: string | null,
  ) {
    this.ppcTypeSlug = ppcTypeSlug;
    this.examen_realise = examen_realise;
    this.microEveils = microEveils;
    this.iahGap = iahGap;
    this.compteRendu = compteRendu;
    this.somnolenceDiurne = somnolenceDiurne;
    this.ronflementsSeveres = ronflementsSeveres;
    this.cephaleesMatinales = cephaleesMatinales;
    this.fatigueDiurne = fatigueDiurne;
    this.nycturie = nycturie;
    this.sensationEtouffement = sensationEtouffement;
    this.somnolenceDiurneSevereRisqueAccidentel =
      somnolenceDiurneSevereRisqueAccidentel;
    this.comorbiditeCardioVasculaireGrave = comorbiditeCardioVasculaireGrave;
    this.comorbiditeRespiratoireGrave = comorbiditeRespiratoireGrave;
    this.oam12DerniersMoisNon = oam12DerniersMoisNon;
    this.reglage = reglage;
    this.recapitulatif = recapitulatif;
  }

  static factory(
    ppcInformationsComplementairesAPI: PpcInformationsComplementairesAPI,
  ): PpcInformationsComplementaires {
    return new PpcInformationsComplementaires(
      ppcInformationsComplementairesAPI.ppc_type_slug,
      ppcInformationsComplementairesAPI.examen_realise,
      ppcInformationsComplementairesAPI.micro_eveils,
      ppcInformationsComplementairesAPI.iah_gap,
      ppcInformationsComplementairesAPI.somnolence_diurne,
      ppcInformationsComplementairesAPI.ronflements_severes,
      ppcInformationsComplementairesAPI.cephalees_matinales,
      ppcInformationsComplementairesAPI.fatigue_diurne,
      ppcInformationsComplementairesAPI.nycturie,
      ppcInformationsComplementairesAPI.sensation_etouffement,
      ppcInformationsComplementairesAPI.somnolence_diurne_severe_risque_accidentel,
      ppcInformationsComplementairesAPI.comorbidite_cardio_vasculaire_grave,
      ppcInformationsComplementairesAPI.comorbidite_respiratoire_grave,
      ppcInformationsComplementairesAPI.oam12_derniers_mois_non,
      ppcInformationsComplementairesAPI.compte_rendu,
      ppcInformationsComplementairesAPI.reglage,
      ppcInformationsComplementairesAPI.recapitulatif,
    );
  }

  toAPI(): PpcInformationsComplementairesAPI {
    return {
      ppc_type_slug: this.ppcTypeSlug,
      examen_realise: this.examen_realise,
      micro_eveils: this.microEveils,
      iah_gap: this.iahGap,
      somnolence_diurne: this.somnolenceDiurne,
      ronflements_severes: this.ronflementsSeveres,
      cephalees_matinales: this.cephaleesMatinales,
      fatigue_diurne: this.fatigueDiurne,
      nycturie: this.nycturie,
      sensation_etouffement: this.sensationEtouffement,
      somnolence_diurne_severe_risque_accidentel:
        this.somnolenceDiurneSevereRisqueAccidentel,
      comorbidite_cardio_vasculaire_grave:
        this.comorbiditeCardioVasculaireGrave,
      comorbidite_respiratoire_grave: this.comorbiditeRespiratoireGrave,
      oam12_derniers_mois_non: this.oam12DerniersMoisNon,
      compte_rendu: this.compteRendu,
      reglage: this.reglage,
      recapitulatif: this.recapitulatif,
    };
  }
}

export type PpcInformationsComplementairesAPI = {
  ppc_type_slug: string;
  examen_realise: 'polysomnographie' | 'polygraphie';
  micro_eveils?: number;
  iah_gap: 'lt15' | 'gt15_lt30' | 'gt30';
  somnolence_diurne: boolean;
  ronflements_severes: boolean;
  cephalees_matinales: boolean;
  fatigue_diurne: boolean;
  nycturie: boolean;
  sensation_etouffement: boolean;
  somnolence_diurne_severe_risque_accidentel: boolean;
  comorbidite_cardio_vasculaire_grave: boolean;
  comorbidite_respiratoire_grave: boolean;
  oam12_derniers_mois_non: boolean;
  compte_rendu?: string;
  reglage?: string;
  recapitulatif?: string | null;
};
